<template>
  <v-card
    :flat="flat"
  >
    <v-card-title>
      <slot name="title"></slot>
    </v-card-title>
    <template v-if="previewEntries !== null && previewCount !== null">
      <v-card-subtitle>
        <b v-if="targetGroup">{{ targetGroup.name }}</b><br>
        {{ targetGroup | filterDescription }}
      </v-card-subtitle>
      <v-card-text>
        <v-list
          dense
          v-if="additionalFilterDescriptions.length"
        >
          <v-list-item
            v-for="desc in additionalFilterDescriptions"
            :key="desc"
            style="min-height: initial"
          >{{ desc }}
          </v-list-item>
        </v-list>
        <v-divider/>
        <v-list
          v-if="previewEntries.length"
          dense
        >
          <v-list-item class="text-overline">Vorschau ({{ previewCount }} Ergebnisse)</v-list-item>
          <v-list-item
            v-for="(previewEntry, index) in previewEntries"
            :key="previewEntry.id"
            style="min-height: initial"
          >
            <v-list-item-icon style="height: auto" class="ma-0">{{ index + 1 }}</v-list-item-icon>
            {{ previewEntry.rufname }} {{ previewEntry.familienname }},
            {{ previewEntry.strassenname }},
            {{ previewEntry.kommune }}
          </v-list-item>
          <v-list-item v-if="previewEntries && previewEntries.length < previewCount" style="min-height: initial">
            <v-list-item-icon style="height: auto" class="ma-0">&hellip;</v-list-item-icon>
            <i>{{ previewCount - previewEntries.length }} weitere Einträge</i>
          </v-list-item>
        </v-list>
      </v-card-text>
    </template>
    <v-skeleton-loader v-else type="article,list-item@6" boilerplate
                       style="filter: blur(6px)"></v-skeleton-loader>
    <v-card-actions>
      <slot name="actions"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { describeFilter } from "@/modules/kirchgeld/utils"

export default {
  name: 'FilterEntriesPreviewCard',
  props: {
    targetGroup: {
      type: Object,
      required: true
    },
    previewEntries: {
      type: Array,
    },
    previewCount: {
      type: Number,
      required: true
    },
    additionalFilterDescriptions: {
      type: Array,
      default: () => []
    },
    flat: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    filterDescription (v) {
      return describeFilter(v?.filter || [])
    }
  },
}
</script>
